import { render, staticRenderFns } from "./SourcesSelectField.vue?vue&type=template&id=50219a7b&scoped=true&"
import script from "./SourcesSelectField.vue?vue&type=script&lang=js&"
export * from "./SourcesSelectField.vue?vue&type=script&lang=js&"
import style0 from "./SourcesSelectField.vue?vue&type=style&index=0&id=50219a7b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50219a7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
